export default () => {
    const watchers = {
        node_double_click({node, event}) {
            if (
                1 < this.selectedNodes.size ||
                this.isNodeEditingText(node)
            ) {
                return
            }

            event.stopPropagation()
            const text = this.getNodeText(node)
            this.startEditNodeText(node, text)
        },
    }

    return {watchers}
}
